import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { parseISO, format } from 'date-fns';

import { UnidataTable } from '~/components';
import { t } from '~/helpers';
import { getToastErrors } from '~/helpers/errorsRequest';
import api from '~/services/api';
import {
  recordFiltering,
  findData,
} from '~/store/modules/EdicaoOperacao/Turno/actions';

import { Accounting, Closing, Form } from './components';
import * as S from './styles';

export default function Turno() {
  const [loading, setLoading] = useState(false);
  const [shifts, setShifts] = useState({});
  const [params, setParams] = useState({
    idShift: '',
    idTank: '',
  });

  const redux = useSelector((state) => state.turno);

  const queryResponse = useMemo(
    () => ({
      wherefield: ['statusturno','tipoposto'],
      valuewherefield: ['F','P'],
      typewherefield: ['EQUALS', 'EQUALS'],
    }),
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'datahorainicialturno',
        label: t('s.cadastro.contrato.datainicialcontrato'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'initialdatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 00:00:00'),
        },
      },
      {
        id: 'datahorafinalturno',
        label: t('s.cadastro.contrato.datafinalcontrato'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
        filter: {
          type: 'finaldatetime',
          defaultValue: format(new Date(), 'dd/MM/yyyy 23:59:59'),
        },
      },
      {
        id: 'codigonomeposto',
        label: t('s.relatorio.geral.unidade'),
        filter: {
          type: 'text',
        },
      },
      { id: 'nomeusuarioinicialturno', label: t('Operador de Abertura') },
      { id: 'nomeusuariofinallturno', label: t('Operador de Fechamento') },
    ],
    []
  );

  const handleGetResponseShifts = useCallback(async ({ idShift, idTank }) => {
    try {
      setLoading(true);

      if (typeof idShift !== 'undefined' && typeof idTank !== 'undefined') {
        const response = await api.get(`/turnos/${idShift}/${idTank}`);
        setShifts(response.data);
      }
    } catch (err) {
      getToastErrors(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (params.idShift) {
      handleGetResponseShifts(params);
    }
  }, [redux.loading, params]);

  return (
    <S.Wrapper>
      <UnidataTable
        fixed
        redux={redux}
        header={header}
        read={recordFiltering}
        find={findData}
        query={queryResponse}
        form={Form}
        onRow={(value) =>
          setParams({
            idShift: value?.idturno,
            idTank: value?.idposto,
          })
        }
        delete={false}
        keys={['idturno', 'idposto']}
        detach="nomeabreviadoposto"
        maxHeight="30rem"
        maxWidth="lg"
      />

      <Closing data={shifts.bicos ?? []} loading={loading} />

      <Accounting data={shifts.tanques ?? []} loading={loading} />
    </S.Wrapper>
  );
}
